// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../Config.bs.js";
import * as Js_dict from "../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_List from "../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_format from "../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as DateTime$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as UrlUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as QueryParamsConstructor$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/query-params/QueryParamsConstructor.bs.js";

function getRedirectPath(params) {
  var deconstructedParams = new URLSearchParams(params);
  var url = window.decodeURIComponent(Belt_Option.getWithDefault(Caml_option.nullable_to_opt(deconstructedParams.get("internal_path")), ""));
  var title = window.decodeURIComponent(Belt_Option.getWithDefault(Caml_option.nullable_to_opt(deconstructedParams.get("internal_title")), "New Tab"));
  return {
          TAG: /* InternalRedirectPath */22,
          path: url,
          title: title
        };
}

function getCrmTab(url) {
  var urlSearchParams = window.decodeURI(url.search);
  var match = url.path;
  if (!match) {
    return ;
  }
  var crn = match.hd;
  switch (crn) {
    case "allocation_dashboard" :
        if (!match.tl) {
          return /* AllocationDashboard */1;
        }
        break;
    case "campaign_orders" :
        var match$1 = match.tl;
        if (!match$1) {
          return ;
        }
        var match$2 = match$1.tl;
        if (match$2) {
          if (match$2.tl) {
            return ;
          } else {
            return {
                    TAG: /* CampaignOrders */46,
                    _0: match$1.hd,
                    _1: match$2.hd
                  };
          }
        }
        break;
    case "create_customer" :
        if (!match.tl) {
          var urlParams = UrlUtils$Catalyst.getURLParams(url.search);
          var phone_number = Belt_Option.getWithDefault(Js_dict.get(urlParams, "phone_number"), "");
          return {
                  TAG: /* UnknownCaller */4,
                  _0: phone_number
                };
        }
        break;
    case "customer_info" :
        if (!match.tl) {
          var urlParams$1 = UrlUtils$Catalyst.getURLParams(url.search);
          var phone_number$1 = Belt_Option.getWithDefault(Js_dict.get(urlParams$1, "phone_number"), "");
          var customer_id = Belt_Option.getWithDefault(Js_dict.get(urlParams$1, "customer_id"), "");
          return {
                  TAG: /* CustomerProfileNew */2,
                  _0: phone_number$1,
                  _1: customer_id
                };
        }
        break;
    case "customer_order_history" :
        if (!match.tl) {
          var urlParams$2 = UrlUtils$Catalyst.getURLParams(url.search);
          var customer_uuid = Belt_Option.getWithDefault(Js_dict.get(urlParams$2, "customer_uuid"), "");
          return {
                  TAG: /* CustomerOrder */3,
                  _0: customer_uuid
                };
        }
        break;
    case "demo_components" :
        if (!match.tl) {
          return /* Test */0;
        }
        break;
    case "driver" :
        var match$3 = match.tl;
        if (!match$3) {
          return ;
        }
        switch (match$3.hd) {
          case "incentives" :
              var match$4 = match$3.tl;
              if (match$4 && !match$4.tl) {
                return {
                        TAG: /* DriverIncentivesList */17,
                        _0: match$4.hd
                      };
              } else {
                return ;
              }
          case "lead_page" :
              if (match$3.tl) {
                return ;
              }
              var urlParams$3 = UrlUtils$Catalyst.getURLParams(url.search);
              var phone_number_list = Belt_Option.getWithDefault(Js_dict.get(urlParams$3, "phone_number"), "");
              return {
                      TAG: /* DriverLeadPage */49,
                      _0: phone_number_list
                    };
          case "mbg_campaign_info" :
              var match$5 = match$3.tl;
              if (match$5 && !match$5.tl) {
                return {
                        TAG: /* MbgCampaignInfo */21,
                        _0: match$5.hd
                      };
              } else {
                return ;
              }
          case "penalties" :
              var match$6 = match$3.tl;
              if (!match$6) {
                return {
                        TAG: /* DriverPenalties */18,
                        _0: "",
                        _1: undefined
                      };
              }
              if (match$6.tl) {
                return ;
              }
              var urlParams$4 = UrlUtils$Catalyst.getURLParams(url.search);
              var crn$1 = Js_dict.get(urlParams$4, "crn");
              return {
                      TAG: /* DriverPenalties */18,
                      _0: match$6.hd,
                      _1: crn$1
                    };
          case "tickets" :
              var match$7 = match$3.tl;
              if (match$7 && !match$7.tl) {
                return {
                        TAG: /* DriverTickets */16,
                        _0: match$7.hd
                      };
              } else {
                return ;
              }
          case "wallet" :
              var match$8 = match$3.tl;
              if (match$8 && !match$8.tl) {
                return {
                        TAG: /* DriverWallet */8,
                        _0: match$8.hd
                      };
              } else {
                return ;
              }
          default:
            
        }
        break;
    case "driver_info" :
        var match$9 = match.tl;
        if (match$9 && !match$9.tl) {
          return {
                  TAG: /* DriverDashboardV2 */5,
                  _0: match$9.hd
                };
        } else {
          return ;
        }
    case "driver_suspension_info" :
        var match$10 = match.tl;
        if (match$10 && !match$10.tl) {
          return {
                  TAG: /* DriverSuspensionList */6,
                  _0: match$10.hd
                };
        } else {
          return ;
        }
    case "driver_termination_info" :
        var match$11 = match.tl;
        if (match$11 && !match$11.tl) {
          return {
                  TAG: /* DriverTerminationList */7,
                  _0: match$11.hd
                };
        } else {
          return ;
        }
    case "edit_driver" :
        var match$12 = match.tl;
        if (match$12 && !match$12.tl) {
          return {
                  TAG: /* EditDriver */15,
                  _0: match$12.hd
                };
        } else {
          return ;
        }
    case "filter" :
        var match$13 = match.tl;
        if (!match$13) {
          return ;
        }
        if (match$13.hd === "partners") {
          if (match$13.tl) {
            return ;
          }
          var urlParams$5 = UrlUtils$Catalyst.getURLParams(urlSearchParams);
          return {
                  TAG: /* FilterPartner */41,
                  _0: urlParams$5
                };
        }
        break;
    case "filter_orders" :
        if (!match.tl) {
          var urlParams$6 = UrlUtils$Catalyst.getURLParams(urlSearchParams);
          return {
                  TAG: /* FilterOrders */40,
                  _0: urlParams$6
                };
        }
        break;
    case "internal_redirect_path" :
        if (!match.tl) {
          return getRedirectPath(url.search);
        }
        break;
    case "order" :
        var match$14 = match.tl;
        if (!match$14) {
          return ;
        }
        var orderId = match$14.hd;
        if (!match$14.tl) {
          return {
                  TAG: /* OrderDetail */9,
                  _0: orderId
                };
        }
        switch (orderId) {
          case "adjust_fare" :
              var match$15 = match$14.tl;
              var orderId$1 = match$15.hd;
              if (!match$15.tl) {
                return {
                        TAG: /* NewAdjustFare */12,
                        _0: orderId$1
                      };
              }
              if (orderId$1 !== "v2") {
                return ;
              }
              var match$16 = match$15.tl;
              if (match$16.tl) {
                return ;
              } else {
                return {
                        TAG: /* NewAdjustFare */12,
                        _0: match$16.hd
                      };
              }
          case "city_toll_routes" :
              var match$17 = match$14.tl;
              var match$18 = match$17.tl;
              if (match$18 && !match$18.tl) {
                return {
                        TAG: /* ViewCityTollRoutes */31,
                        _0: match$17.hd,
                        _1: match$18.hd
                      };
              } else {
                return ;
              }
          case "create_penalty" :
              var match$19 = match$14.tl;
              if (match$19.tl) {
                return ;
              }
              var urlParams$7 = UrlUtils$Catalyst.getURLParams(url.search);
              var msisdn = Js_dict.get(urlParams$7, "msisdn");
              return {
                      TAG: /* CreatePenalty */26,
                      orderId: match$19.hd,
                      msisdn: msisdn
                    };
          case "edit_order" :
              var match$20 = match$14.tl;
              if (match$20.tl) {
                return ;
              }
              var orderId$2 = match$20.hd;
              var match$21 = process.env.INFRA_STACK;
              if (match$21 === "india") {
                return {
                        TAG: /* OrderDetails */10,
                        _0: orderId$2,
                        _1: true
                      };
              } else {
                return {
                        TAG: /* EditOrder */25,
                        _0: orderId$2
                      };
              }
          case "goodwill_discount" :
              var match$22 = match$14.tl;
              if (match$22.tl) {
                return ;
              } else {
                return {
                        TAG: /* GiveGoodwillDiscount */29,
                        _0: match$22.hd
                      };
              }
          case "logs" :
              var match$23 = match$14.tl;
              if (match$23.tl) {
                return ;
              } else {
                return {
                        TAG: /* OrderLogs */13,
                        _0: match$23.hd
                      };
              }
          case "order_fare_details" :
              var match$24 = match$14.tl;
              if (match$24.tl) {
                return ;
              } else {
                return {
                        TAG: /* GetOrderFareDetails */28,
                        _0: match$24.hd
                      };
              }
          case "send_invoice" :
              var match$25 = match$14.tl;
              if (match$25.tl) {
                return ;
              }
              var urlParams$8 = UrlUtils$Catalyst.getURLParams(url.search);
              var orderId$3 = Belt_Option.getWithDefault(Js_dict.get(urlParams$8, "order_id"), "");
              return {
                      TAG: /* SendInvoice */27,
                      orderCrn: match$25.hd,
                      orderId: orderId$3
                    };
          case "sms_details" :
              var match$26 = match$14.tl;
              if (match$26.tl) {
                return ;
              } else {
                return {
                        TAG: /* SMSDetails */30,
                        _0: match$26.hd
                      };
              }
          case "view_ticket" :
              var match$27 = match$14.tl;
              if (match$27.tl) {
                return ;
              } else {
                return {
                        TAG: /* ViewTickets */23,
                        _0: match$27.hd
                      };
              }
          default:
            
        }
        break;
    case "order_fare" :
        var match$28 = match.tl;
        if (match$28 && !match$28.tl) {
          return {
                  TAG: /* OrderFare */11,
                  order_crn: match$28.hd
                };
        } else {
          return ;
        }
    case "porter_store" :
        if (!match.tl) {
          return /* PorterStore */3;
        }
        break;
    case "pretend_as_caller" :
        if (!match.tl) {
          var urlParams$9 = UrlUtils$Catalyst.getURLParams(url.search);
          var phone_number$2 = Js_dict.get(urlParams$9, "phone_number");
          return {
                  TAG: /* PretendAsCaller */0,
                  _0: phone_number$2
                };
        }
        break;
    case "pricing_dashboard" :
        var match$29 = match.tl;
        if (!match$29) {
          return ;
        }
        if (match$29.hd === "geo_region") {
          var match$30 = match$29.tl;
          if (match$30 && !match$30.tl) {
            return {
                    TAG: /* PricingDashboard */44,
                    geo_region_id: Caml_format.caml_int_of_string(match$30.hd)
                  };
          } else {
            return ;
          }
        }
        break;
    case "raise_ticket" :
        var match$31 = match.tl;
        if (match$31) {
          if (match$31.hd === "agent_desk") {
            if (match$31.tl) {
              return ;
            }
            var urlParams$10 = UrlUtils$Catalyst.getURLParams(urlSearchParams);
            return {
                    TAG: /* RaiseTicketFromAgentDesk */33,
                    _0: urlParams$10
                  };
          }
          
        } else {
          var urlParams$11 = UrlUtils$Catalyst.getURLParams(url.search);
          var crn$2 = Js_dict.get(urlParams$11, "crn");
          return {
                  TAG: /* RaiseTicket */14,
                  _0: crn$2
                };
        }
        break;
    case "send_sms" :
        if (!match.tl) {
          return /* SendSMS */2;
        }
        break;
    case "surge_dashboard" :
        var match$32 = match.tl;
        if (match$32 && !match$32.tl) {
          return {
                  TAG: /* SurgeDashboard */20,
                  _0: Caml_format.caml_int_of_string(match$32.hd)
                };
        } else {
          return ;
        }
    case "ticket" :
        var match$33 = match.tl;
        if (!match$33) {
          return ;
        }
        if (match$33.hd === "list") {
          if (match$33.tl) {
            return ;
          }
          var urlParams$12 = UrlUtils$Catalyst.getURLParams(urlSearchParams);
          return {
                  TAG: /* Tickets */42,
                  _0: urlParams$12
                };
        }
        break;
    case "tns" :
        var match$34 = match.tl;
        if (!match$34) {
          return {
                  TAG: /* TrustAndSafety */47,
                  feature: /* BulkSuspensions */0,
                  msisdn: undefined
                };
        }
        switch (match$34.hd) {
          case "bulk" :
              var match$35 = match$34.tl;
              if (!match$35) {
                return ;
              }
              if (match$35.hd !== "suspensions") {
                return ;
              }
              if (match$35.tl) {
                return ;
              }
              var urlParams$13 = UrlUtils$Catalyst.getURLParams(url.search);
              var msisdn$1 = Js_dict.get(urlParams$13, "msisdn");
              return {
                      TAG: /* TrustAndSafety */47,
                      feature: /* BulkSuspensions */0,
                      msisdn: msisdn$1
                    };
          case "partner" :
              var match$36 = match$34.tl;
              if (!match$36) {
                return ;
              }
              if (match$36.hd !== "blacklist") {
                return ;
              }
              if (match$36.tl) {
                return ;
              }
              var urlParams$14 = UrlUtils$Catalyst.getURLParams(url.search);
              var msisdn$2 = Js_dict.get(urlParams$14, "msisdn");
              return {
                      TAG: /* TrustAndSafety */47,
                      feature: /* PartnerBlacklist */1,
                      msisdn: msisdn$2
                    };
          case "wallet" :
              var match$37 = match$34.tl;
              if (!match$37) {
                return ;
              }
              if (match$37.hd !== "withdrawal") {
                return ;
              }
              var match$38 = match$37.tl;
              if (!match$38) {
                return ;
              }
              if (match$38.hd !== "block") {
                return ;
              }
              if (match$38.tl) {
                return ;
              }
              var urlParams$15 = UrlUtils$Catalyst.getURLParams(url.search);
              var msisdn$3 = Js_dict.get(urlParams$15, "msisdn");
              return {
                      TAG: /* TrustAndSafety */47,
                      feature: /* WalletWithdrawalBlock */2,
                      msisdn: msisdn$3
                    };
          default:
            
        }
        break;
    case "v2" :
        var match$39 = match.tl;
        if (!match$39) {
          return ;
        }
        switch (match$39.hd) {
          case "driver_info" :
              var match$40 = match$39.tl;
              if (match$40 && !match$40.tl) {
                return {
                        TAG: /* DriverDashboardV2 */5,
                        _0: match$40.hd
                      };
              } else {
                return ;
              }
          case "order" :
              var match$41 = match$39.tl;
              if (!match$41) {
                return ;
              }
              if (match$41.tl) {
                return ;
              }
              var urlParams$16 = UrlUtils$Catalyst.getURLParams(url.search);
              var value = Js_dict.get(urlParams$16, "is_edit_order_open");
              var is_edit_order_open = value !== undefined ? value === "true" : undefined;
              return {
                      TAG: /* OrderDetails */10,
                      _0: match$41.hd,
                      _1: is_edit_order_open
                    };
          default:
            
        }
        break;
    case "v3" :
        var match$42 = match.tl;
        if (!match$42) {
          return ;
        }
        if (match$42.hd === "order") {
          var match$43 = match$42.tl;
          if (!match$43) {
            return ;
          }
          if (match$43.tl) {
            return ;
          }
          var urlParams$17 = UrlUtils$Catalyst.getURLParams(url.search);
          var value$1 = Js_dict.get(urlParams$17, "is_edit_order_open");
          var is_edit_order_open$1 = value$1 !== undefined ? value$1 === "true" : undefined;
          return {
                  TAG: /* OrderDetails */10,
                  _0: match$43.hd,
                  _1: is_edit_order_open$1
                };
        }
        break;
    default:
      
  }
  var match$44 = match.tl;
  if (!match$44) {
    return ;
  }
  if (match$44.hd === "partner_goodwill_bonus") {
    if (match$44.tl) {
      return ;
    }
    var urlParams$18 = UrlUtils$Catalyst.getURLParams(url.search);
    var msisdn$4 = Js_dict.get(urlParams$18, "msisdn");
    return {
            TAG: /* GiveGoodwillPartnerBonus */32,
            crn: crn,
            msisdn: msisdn$4
          };
  }
  switch (crn) {
    case "helper_labour_serviceability" :
        var match$45 = match.tl;
        if (match$45.tl) {
          return ;
        } else {
          return {
                  TAG: /* HelperLabourServiceability */45,
                  msisdn: match$45.hd
                };
        }
    case "helper_serviceability_info" :
        var match$46 = match.tl;
        if (match$46.tl) {
          return ;
        } else {
          return {
                  TAG: /* HelperServiceabilityInfoList */36,
                  _0: match$46.hd
                };
        }
    case "outstation_serviceability_info" :
        var match$47 = match.tl;
        if (match$47.tl) {
          return ;
        } else {
          return {
                  TAG: /* OutStationServiceabilityInfoList */37,
                  _0: match$47.hd
                };
        }
    case "pp_susbscription_logs" :
        var match$48 = match.tl;
        if (match$48.tl) {
          return ;
        } else {
          return {
                  TAG: /* PremiumPartnerReport */39,
                  msisdn: match$48.hd
                };
        }
    case "rental_serviceability_info" :
        var match$49 = match.tl;
        if (match$49.tl) {
          return ;
        } else {
          return {
                  TAG: /* RentalServiceabilityInfoList */38,
                  _0: match$49.hd
                };
        }
    case "ticket" :
        var match$50 = match.tl;
        if (match$50.tl) {
          return ;
        } else {
          return {
                  TAG: /* Ticket */43,
                  case_number: match$50.hd
                };
        }
    default:
      return ;
  }
}

function getPathNameFromTab(tab, old_hash) {
  var newHashTs = Belt_Option.getWithDefault(old_hash, String(DateTime$Catalyst.toTimeStamp(DateTime$Catalyst.now(undefined))));
  if (typeof tab === "number") {
    switch (tab) {
      case /* Test */0 :
          return {
                  path: {
                    hd: "demo_components",
                    tl: /* [] */0
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* AllocationDashboard */1 :
          return {
                  path: {
                    hd: "allocation_dashboard",
                    tl: /* [] */0
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* SendSMS */2 :
          return {
                  path: {
                    hd: "send_sms",
                    tl: /* [] */0
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* PorterStore */3 :
          return {
                  path: {
                    hd: "porter_store",
                    tl: /* [] */0
                  },
                  hash: newHashTs,
                  search: ""
                };
      
    }
  } else {
    switch (tab.TAG | 0) {
      case /* PretendAsCaller */0 :
          var phone_number = tab._0;
          return {
                  path: {
                    hd: "pretend_as_caller",
                    tl: /* [] */0
                  },
                  hash: newHashTs,
                  search: phone_number !== undefined ? "phone_number=" + phone_number : ""
                };
      case /* CustomerCallerInfo */1 :
          return {
                  path: {
                    hd: "crm",
                    tl: {
                      hd: "customer",
                      tl: {
                        hd: "profile",
                        tl: /* [] */0
                      }
                    }
                  },
                  hash: newHashTs,
                  search: "customer_id=" + tab._0
                };
      case /* CustomerProfileNew */2 :
          return {
                  path: {
                    hd: "customer_info",
                    tl: /* [] */0
                  },
                  hash: newHashTs,
                  search: "phone_number=" + tab._0 + "&customer_id=" + tab._1
                };
      case /* CustomerOrder */3 :
          return {
                  path: {
                    hd: "customer_order_history",
                    tl: /* [] */0
                  },
                  hash: newHashTs,
                  search: "customer_uuid=" + tab._0
                };
      case /* UnknownCaller */4 :
          return {
                  path: {
                    hd: "create_customer",
                    tl: /* [] */0
                  },
                  hash: newHashTs,
                  search: "phone_number=" + tab._0
                };
      case /* DriverDashboardV2 */5 :
          return {
                  path: {
                    hd: "v2",
                    tl: {
                      hd: "driver_info",
                      tl: {
                        hd: tab._0,
                        tl: /* [] */0
                      }
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* DriverSuspensionList */6 :
          return {
                  path: {
                    hd: "driver_suspension_info",
                    tl: {
                      hd: tab._0,
                      tl: /* [] */0
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* DriverTerminationList */7 :
          return {
                  path: {
                    hd: "driver_termination_info",
                    tl: {
                      hd: tab._0,
                      tl: /* [] */0
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* DriverWallet */8 :
          return {
                  path: {
                    hd: "driver",
                    tl: {
                      hd: "wallet",
                      tl: {
                        hd: tab._0,
                        tl: /* [] */0
                      }
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* OrderDetail */9 :
          return {
                  path: {
                    hd: "order",
                    tl: {
                      hd: tab._0,
                      tl: /* [] */0
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* OrderDetails */10 :
          var is_edit_order_open = tab._1;
          return {
                  path: {
                    hd: "v3",
                    tl: {
                      hd: "order",
                      tl: {
                        hd: tab._0,
                        tl: /* [] */0
                      }
                    }
                  },
                  hash: newHashTs,
                  search: is_edit_order_open !== undefined ? "is_edit_order_open=" + (
                      is_edit_order_open === true ? "true" : "false"
                    ) : ""
                };
      case /* OrderFare */11 :
          return {
                  path: {
                    hd: "order_fare",
                    tl: {
                      hd: tab.order_crn,
                      tl: /* [] */0
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* NewAdjustFare */12 :
          return {
                  path: {
                    hd: "order",
                    tl: {
                      hd: "adjust_fare",
                      tl: {
                        hd: "v2",
                        tl: {
                          hd: tab._0,
                          tl: /* [] */0
                        }
                      }
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* OrderLogs */13 :
          return {
                  path: {
                    hd: "order",
                    tl: {
                      hd: "logs",
                      tl: {
                        hd: tab._0,
                        tl: /* [] */0
                      }
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* RaiseTicket */14 :
          var crn = tab._0;
          return {
                  path: {
                    hd: "raise_ticket",
                    tl: /* [] */0
                  },
                  hash: newHashTs,
                  search: crn !== undefined ? "crn=" + crn : ""
                };
      case /* EditDriver */15 :
          return {
                  path: {
                    hd: "edit_driver",
                    tl: {
                      hd: tab._0,
                      tl: /* [] */0
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* DriverTickets */16 :
          return {
                  path: {
                    hd: "driver",
                    tl: {
                      hd: "tickets",
                      tl: {
                        hd: tab._0,
                        tl: /* [] */0
                      }
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* DriverIncentivesList */17 :
          return {
                  path: {
                    hd: "driver",
                    tl: {
                      hd: "incentives",
                      tl: {
                        hd: tab._0,
                        tl: /* [] */0
                      }
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* DriverPenalties */18 :
          return {
                  path: {
                    hd: "driver",
                    tl: {
                      hd: "penalties",
                      tl: {
                        hd: tab._0,
                        tl: /* [] */0
                      }
                    }
                  },
                  hash: newHashTs,
                  search: Belt_Option.mapWithDefault(tab._1, "", (function (crn) {
                          return "crn=" + crn;
                        }))
                };
      case /* DriverWeeklyEarningDetails */19 :
          return {
                  path: {
                    hd: "driver_info",
                    tl: {
                      hd: tab._0,
                      tl: {
                        hd: "earning_details",
                        tl: {
                          hd: DateTime$Catalyst.toString("YYYY-MM-DD", tab._1),
                          tl: /* [] */0
                        }
                      }
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* SurgeDashboard */20 :
          return {
                  path: {
                    hd: "surge_dashboard",
                    tl: {
                      hd: String(tab._0),
                      tl: /* [] */0
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* MbgCampaignInfo */21 :
          return {
                  path: {
                    hd: "driver",
                    tl: {
                      hd: "mbg_campaign_info",
                      tl: {
                        hd: tab._0,
                        tl: /* [] */0
                      }
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* InternalRedirectPath */22 :
          var url = Belt_Option.getWithDefault(tab.path, "");
          var label = window.decodeURIComponent(Belt_Option.getWithDefault(Belt_Option.flatMap(tab.path, (function (_path) {
                          return tab.title;
                        })), "New Tab"));
          return {
                  path: {
                    hd: "internal_redirect_path",
                    tl: /* [] */0
                  },
                  hash: newHashTs,
                  search: "internal_path=" + (window.encodeURIComponent(url) + ("&internal_title=" + window.encodeURIComponent(label)))
                };
      case /* ViewTickets */23 :
          return {
                  path: {
                    hd: "order",
                    tl: {
                      hd: "view_ticket",
                      tl: {
                        hd: tab._0,
                        tl: /* [] */0
                      }
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* ViewTicketDetails */24 :
          return {
                  path: {
                    hd: "administrators",
                    tl: {
                      hd: "ticketing",
                      tl: {
                        hd: "view_ticket_details",
                        tl: /* [] */0
                      }
                    }
                  },
                  hash: newHashTs,
                  search: "case_number=" + tab._0
                };
      case /* EditOrder */25 :
          return {
                  path: {
                    hd: "order",
                    tl: {
                      hd: "edit_order",
                      tl: {
                        hd: tab._0,
                        tl: /* [] */0
                      }
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* CreatePenalty */26 :
          return {
                  path: {
                    hd: "order",
                    tl: {
                      hd: "create_penalty",
                      tl: {
                        hd: tab.orderId,
                        tl: /* [] */0
                      }
                    }
                  },
                  hash: newHashTs,
                  search: Belt_Option.mapWithDefault(tab.msisdn, "", (function (msisdn) {
                          return "msisdn=" + msisdn;
                        }))
                };
      case /* SendInvoice */27 :
          return {
                  path: {
                    hd: "order",
                    tl: {
                      hd: "send_invoice",
                      tl: {
                        hd: tab.orderCrn,
                        tl: /* [] */0
                      }
                    }
                  },
                  hash: newHashTs,
                  search: "order_id=" + tab.orderId
                };
      case /* GetOrderFareDetails */28 :
          return {
                  path: {
                    hd: "order",
                    tl: {
                      hd: "order_fare_details",
                      tl: {
                        hd: tab._0,
                        tl: /* [] */0
                      }
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* GiveGoodwillDiscount */29 :
          return {
                  path: {
                    hd: "order",
                    tl: {
                      hd: "goodwill_discount",
                      tl: {
                        hd: tab._0,
                        tl: /* [] */0
                      }
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* SMSDetails */30 :
          return {
                  path: {
                    hd: "order",
                    tl: {
                      hd: "sms_details",
                      tl: {
                        hd: tab._0,
                        tl: /* [] */0
                      }
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* ViewCityTollRoutes */31 :
          return {
                  path: {
                    hd: "order",
                    tl: {
                      hd: "city_toll_routes",
                      tl: {
                        hd: tab._0,
                        tl: {
                          hd: tab._1,
                          tl: /* [] */0
                        }
                      }
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* GiveGoodwillPartnerBonus */32 :
          return {
                  path: {
                    hd: tab.crn,
                    tl: {
                      hd: "partner_goodwill_bonus",
                      tl: /* [] */0
                    }
                  },
                  hash: newHashTs,
                  search: Belt_Option.mapWithDefault(tab.msisdn, "", (function (msisdn) {
                          return "msisdn=" + msisdn;
                        }))
                };
      case /* RaiseTicketFromAgentDesk */33 :
          var params = QueryParamsConstructor$Catalyst.create(tab._0);
          return {
                  path: {
                    hd: "raise_ticket",
                    tl: {
                      hd: "agent_desk",
                      tl: /* [] */0
                    }
                  },
                  hash: newHashTs,
                  search: params !== undefined ? params : ""
                };
      case /* EditTicket */34 :
          return {
                  path: {
                    hd: "raise_ticket",
                    tl: /* [] */0
                  },
                  hash: newHashTs,
                  search: "crn=" + tab._0
                };
      case /* CustomerProfile */35 :
          return {
                  path: {
                    hd: "administrators",
                    tl: {
                      hd: "customer_account_details",
                      tl: /* [] */0
                    }
                  },
                  hash: newHashTs,
                  search: "customer_id=" + tab._0
                };
      case /* HelperServiceabilityInfoList */36 :
          return {
                  path: {
                    hd: "helper_serviceability_info",
                    tl: {
                      hd: tab._0,
                      tl: /* [] */0
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* OutStationServiceabilityInfoList */37 :
          return {
                  path: {
                    hd: "outstation_serviceability_info",
                    tl: {
                      hd: tab._0,
                      tl: /* [] */0
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* RentalServiceabilityInfoList */38 :
          return {
                  path: {
                    hd: "rental_serviceability_info",
                    tl: {
                      hd: tab._0,
                      tl: /* [] */0
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* PremiumPartnerReport */39 :
          return {
                  path: {
                    hd: "pp_susbscription_logs",
                    tl: {
                      hd: tab.msisdn,
                      tl: /* [] */0
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* FilterOrders */40 :
          var params$1 = QueryParamsConstructor$Catalyst.create(tab._0);
          return {
                  path: {
                    hd: "filter_orders",
                    tl: /* [] */0
                  },
                  hash: newHashTs,
                  search: params$1 !== undefined ? params$1 : ""
                };
      case /* FilterPartner */41 :
          var params$2 = QueryParamsConstructor$Catalyst.create(tab._0);
          return {
                  path: {
                    hd: "filter",
                    tl: {
                      hd: "partners",
                      tl: /* [] */0
                    }
                  },
                  hash: newHashTs,
                  search: params$2 !== undefined ? params$2 : ""
                };
      case /* Tickets */42 :
          var params$3 = QueryParamsConstructor$Catalyst.create(tab._0);
          return {
                  path: {
                    hd: "ticket",
                    tl: {
                      hd: "list",
                      tl: /* [] */0
                    }
                  },
                  hash: newHashTs,
                  search: params$3 !== undefined ? params$3 : ""
                };
      case /* Ticket */43 :
          return {
                  path: {
                    hd: "ticket",
                    tl: {
                      hd: tab.case_number,
                      tl: /* [] */0
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* PricingDashboard */44 :
          return {
                  path: {
                    hd: "pricing_dashboard",
                    tl: {
                      hd: "geo_region",
                      tl: {
                        hd: String(tab.geo_region_id),
                        tl: /* [] */0
                      }
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* HelperLabourServiceability */45 :
          return {
                  path: {
                    hd: "helper_labour_serviceability",
                    tl: {
                      hd: tab.msisdn,
                      tl: /* [] */0
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* CampaignOrders */46 :
          return {
                  path: {
                    hd: "campaign_orders",
                    tl: {
                      hd: tab._0,
                      tl: {
                        hd: tab._1,
                        tl: /* [] */0
                      }
                    }
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* TrustAndSafety */47 :
          var tmp;
          switch (tab.feature) {
            case /* BulkSuspensions */0 :
                tmp = {
                  hd: "tns",
                  tl: {
                    hd: "bulk",
                    tl: {
                      hd: "suspensions",
                      tl: /* [] */0
                    }
                  }
                };
                break;
            case /* PartnerBlacklist */1 :
                tmp = {
                  hd: "tns",
                  tl: {
                    hd: "partner",
                    tl: {
                      hd: "blacklist",
                      tl: /* [] */0
                    }
                  }
                };
                break;
            case /* WalletWithdrawalBlock */2 :
                tmp = {
                  hd: "tns",
                  tl: {
                    hd: "wallet",
                    tl: {
                      hd: "withdrawal",
                      tl: {
                        hd: "block",
                        tl: /* [] */0
                      }
                    }
                  }
                };
                break;
            
          }
          return {
                  path: tmp,
                  hash: newHashTs,
                  search: Belt_List.toArray(Belt_List.keepMap({
                              hd: Belt_Option.map(tab.msisdn, (function (id) {
                                      return "msisdn=" + id;
                                    })),
                              tl: /* [] */0
                            }, (function (x) {
                                return x;
                              }))).join("&")
                };
      case /* PlaceOrder */48 :
          return {
                  path: {
                    hd: "place_order",
                    tl: /* [] */0
                  },
                  hash: newHashTs,
                  search: ""
                };
      case /* DriverLeadPage */49 :
          return {
                  path: {
                    hd: "driver",
                    tl: {
                      hd: "lead_page",
                      tl: /* [] */0
                    }
                  },
                  hash: newHashTs,
                  search: "phone_number=" + tab._0
                };
      
    }
  }
}

function getRouteFromTab(_tab) {
  return Config.Env.getCrmBaseUrl(undefined);
}

export {
  getRedirectPath ,
  getCrmTab ,
  getPathNameFromTab ,
  getRouteFromTab ,
  
}
/* Config Not a pure module */
